import _ from 'lodash'
import { SEVERITY_ERROR, SEVERITY_INFO, SEVERITY_WARNING, SEVERITY_SUCCESS } from './constants'

const mapper = {
    [SEVERITY_ERROR]: 'error',
    [SEVERITY_INFO]: 'info',
    [SEVERITY_SUCCESS]: 'success',
    [SEVERITY_WARNING]: 'warning',
}

export function getMappedSeverity(severity) {
    return mapper[severity]
}

export function getToasts(state) {
    // 1. I want to create a queue that is ordered
    // 2. I want it to include at most x items
    // 3. I want it to only show items that are in a specific queue
    // 4. AlwaysOnTop should be included as well
    // 5. The ordering should be dependant on state as well

    if (_.isEmpty(state.data)) return []

    // Start by only picking the toasts that have not been dismissed
    const toasts = _.pickBy(
        state.data,
        toast =>
            // Not dismissed
            toast.dismissed == null &&
            // Is visible
            toast.visible,
    )

    // Now sort them by last updated date
    let result = _.sortBy(toasts, toast => toast.updated)

    let counter = 0
    // Now remove all but 2 messages
    result = _.reduce(
        result,
        (r, toast) => {
            // Only add at most 2 messages
            if (toast.isMessage) {
                if (counter < 2) {
                    // Only add message if it is unseen, or if it is the newest message
                    if (!toast.seen || toast.id === state.newestMessage.id) {
                        r.push(toast)
                        counter += 1
                    }
                }
            } else {
                r.push(toast)
            }
            return r
        },
        [],
    )

    return result
}

export function getMotds(state) {
    // Loop through all the toasts we have...
    const motds = _.reduce(
        state.data,
        (result, toast) => {
            if (!toast.isMessage) return result

            // We have a message so now we create a new item
            const motd = { ...toast.tag }
            motd.seen = toast.seen

            // We always add the newest motd, and all unseen messages
            // all other messages can be safely discarded
            if (toast.id === state.newestMessage.id || !toast.seen) {
                result[motd.id] = motd
            }

            return result
        },
        {},
    )
    return {
        motds,
        newestMotd: {
            id: state.newestMessage.id,
            timeStamp: state.newestMessage.timeStamp,
        },
    }
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/toasts/selectors.js